/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ActivateRequest {
    getFixupPrototypeFunction() { return ActivateRequest.fixupPrototype; }

    static newInstance(model: Partial<ActivateRequest>): ActivateRequest {
        let obj = Object.assign(new ActivateRequest(), model);
        ActivateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ActivateRequest>): ActivateRequest {
        if (!model) return null;
        return ActivateRequest.newInstance(<ActivateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ActivateRequest) {
        if (!obj) return;

        models.ActivateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ActivateRequest): boolean {
        Object.setPrototypeOf(obj, ActivateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * user password
     */
    password: string;

}
